
import { useSearchParams } from "react-router-dom"
import Header from "../../../../../Components/Header/Header"
import Sidebar from "../../../../../Components/Sidebar/Sidebar"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Get_Piller_Current_RatingDataAPI } from "../../../../../Redux/ReportExecutionSlice/ReportExecutionSlice"
import { useAuthState } from "../../../../../Helper/Context"
import { Loading } from "../../../../../Helper/Loading"
import { MonthDataDDL } from "../../../../../Components/CommonDDL/MonthDataDDL"
import ExecutionDateModal from "./Modal/ExecutionDateModal"
import { FinancialYearDataDDL } from "../../../../../Components/CommonDDL/FinancialYearDataDDL"
import { PillerCurrentRatingTableData } from "../../../../../Helper/Data"
import { WardNameDataDDL } from "../../../../../Components/CommonDDL/WardNameDataDDL"
import { toastInfo } from "../../../../../Helper/ToastMessage"
import { BaseUrl } from "../../../../../Helper/BaseUrl"
import { VendorNameDDL } from "../../../../../Components/CommonDDL/VendorNameDDL"

export const ReportExe = () => {

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")

    const [ReportFromDate, setReportFromDate] = useState('')
    const [PDFUrl, setPDFUrl] = useState(null)
    const [loading, setloading] = useState(false)
    const [ExecutionDateViewPopUp, setExecutionDateViewPopUp] = useState(false)
    const [GridData, setGridData] = useState(false)


    const handleView = (data) => {
        setExecutionDateViewPopUp(true)
        setGridData(data)
    }
    const handleViewClose = (data) => {
        setExecutionDateViewPopUp(false)
        setGridData('')
    }


    const [Month, setMonth] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [WardName, setWardName] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })
    const [VendorName, setVendorName] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })

    const handleClear = () => {
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
        // setFinancialYear({
        //     ...FinancialYear,
        //     ID: 0,
        //     Label: 'Select...',
        // })
        // setMonth({
        //     ...Month,
        //     ID: 0,
        //     Label: 'Select...',
        // })
        setPDFUrl(null)
        handleGetData(true)
    }

    // useEffect(() => {
    //     handleGetData()
    // }, [FinancialYear.ID, Month.ID, WardName.ID])

    const handleGetData = (IsClear) => {
        setPDFUrl(null)
        const data = {
            M_FinancialYearID: FinancialYear.ID,
            M_MonthID: Month.ID,
            M_Ward_Wise_VendorID: VendorName?.ID,
            M_WardID: IsClear ? 0 : WardName.ID,

            token: token,
            setPDFUrl: setPDFUrl
        }
        dispatch(Get_Piller_Current_RatingDataAPI({ data }))
    }

    const { isLoading, TableData } = useSelector(state => state.Get_Piller_Current_RatingData)


    const days = Array.from({ length: 31 }, (_, i) =>
        String(i + 1).padStart(2, "0")
    );

    const handleOpenPDF = () => {
        setloading(true)
        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };

        fetch(`${BaseUrl}/Electrical/Get_RM_DB_ELE_KPI_DumpDataSelect?M_ELEC_WorkID=1&M_WardID=${WardName.ID}&M_FinancialYearID=${FinancialYear.ID}&M_MonthID=${Month.ID}&M_Ward_Wise_VendorID=0`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                setloading(false)
                if (result && result?.status) {
                    window.open(result?.url)
                } else {
                    toastInfo('Report Data Not Found ...')
                }
            })
            .catch((error) => {
                setloading(false)
                toastInfo('Report Data Not Found ...')
                console.error(error)
            });
    }

    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active="ReportExe"
                        listActive="ReportExeee"

                    />
                    <div className="content">
                        <div className="data_mob">
                            <div className="row col-12 m-1 py-1 pb-4 master_border">
                                <div className="col-10">
                                    <h5 className="ps-1 py-1 ">Report</h5>
                                </div>
                                {
                                    RoleID != 45 &&
                                    <div className="col-2 d-flex justify-content-end">
                                        {
                                            (TableData && TableData?.length > 0) &&
                                            <button type="button"
                                                disabled={loading}
                                                className="btn-search btn btn-primary mx-2"
                                                onClick={() => handleOpenPDF()}
                                                style={{ height: '90%' }}
                                            >
                                                {loading ? 'Loading..' : 'PDF'}
                                            </button>
                                        }

                                    </div>
                                }
                                <div className="row m-0 ">
                                    <div className="col-12 py-1  rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12  ">

                                            <div className="row py-1 rounded2">

                                                {/* <div className="col-1 pt-1 pl-4">
                                                    <label for=""><b>Date</b><AstricSign /> : </label>
                                                </div> */}

                                                <div className="col-12 col-md-4 col-lg-2">
                                                    <FinancialYearDataDDL
                                                        FinancialYear={FinancialYear}
                                                        setFinancialYear={setFinancialYear}
                                                        Flag='PenealtyReport'
                                                        isCompulsory={true}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-2">
                                                    <MonthDataDDL
                                                        Month={Month}
                                                        setMonth={setMonth}
                                                        isCompulsory={true}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard='0'
                                                        WLable=''
                                                        Type="Electrical"
                                                        // APIFlag="Master"
                                                        APIFlag={(RoleID == 44 || RoleID == 45 || RoleID == 46) ? "UserWiseM_Ward" : "Master"}
                                                        IsPost=''
                                                    />
                                                </div>
                                                {
                                                    WardName?.ID == 2 &&
                                                    <div className="col-12 col-md-4 col-lg-3">
                                                        <VendorNameDDL
                                                            WardName={WardName}
                                                            VendorName={VendorName}
                                                            setVendorName={setVendorName}
                                                            APIFlag="Master"
                                                        />
                                                    </div>
                                                }
                                                {/* <div className="col-3 col-lg-3">
                                                    <label for=""><b>To Date</b><AstricSign /></label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        id="exampleInputEmail1" name='EmployeeName'
                                                        aria-describedby="emailHelp"
                                                        value={ReportToDate}
                                                        max={moment().format('YYYY-MM-DD')}
                                                        min={moment(ReportFromDate).format('YYYY-MM-DD')}
                                                        onChange={(e) => setReportToDate(e.target.value)}
                                                    />
                                                </div> */}



                                                <div className="col-12 col-md-3 col-lg-2 d-md-flex mt-4" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={() => handleGetData(false)}
                                                    >
                                                        Search</button>

                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>

                                                </div>

                                                {/* {
                                                    TableData && TableData?.length > 0 &&
                                                    <div className="col-12 col-md-3 col-lg-3 mt-4 float-end pr-3" >
                                                        <ExportReportExe
                                                            ExcelData={TableData}
                                                            name="Report"
                                                            days={days}
                                                        />
                                                    </div>
                                                } */}
                                            </div>

                                            <div className="row mob_table table-responsive pt-1" style={{ height: '70vh', overflow: 'scroll' }}>

                                                <table border="1" cellPadding="2" cellSpacing="0" style={{ fontSize: '12px' }}>
                                                    <thead>
                                                        <tr>
                                                            <th>Sr.No</th>
                                                            <th>Sector Name</th>
                                                            <th>Area Name</th>
                                                            <th>MiniPillarNo</th>
                                                            <th>Phase</th>
                                                            <th>Time</th>

                                                            {days.map(day => (
                                                                <th key={day}>{day}</th>
                                                            ))}

                                                            <th>Benchmark Max (amp)</th>
                                                            <th>Min Max (amp)</th>
                                                            {
                                                                (RoleID != 45 && RoleID != 46) &&
                                                                <th>Defaulter (amp)</th>
                                                            }
                                                            <th>Unit Penalty (amp)</th>
                                                            {
                                                                (RoleID != 45 && RoleID != 46) &&
                                                                <th>Total Penalty</th>
                                                            }
                                                        </tr>
                                                    </thead>

                                                    <tbody>

                                                        {
                                                            TableData && TableData?.length > 0 ? TableData.map((pillar, Index) => {
                                                                const totalRows = pillar.phases.reduce(
                                                                    (sum, ph) => sum + ph.records.length,
                                                                    0
                                                                );

                                                                let pillarRendered = false;

                                                                return (
                                                                    <>
                                                                        {pillar.phases.map((phase, phIndex) => {
                                                                            let phaseRendered = false;

                                                                            return phase.records.map((record, rIndex) => (
                                                                                <tr key={`${Index}-${phIndex}-${rIndex}`}>
                                                                                    {/* Left fixed columns */}
                                                                                    {!pillarRendered && (
                                                                                        <>
                                                                                            <td rowSpan={totalRows} align="center">{Index + 1}</td>
                                                                                            <td rowSpan={totalRows}>{pillar.sectorName}</td>
                                                                                            <td rowSpan={totalRows}>{pillar.areaName || "-"}</td>
                                                                                            <td rowSpan={totalRows}>{pillar.miniPillarNo}</td>
                                                                                        </>
                                                                                    )}

                                                                                    {/* Phase column */}
                                                                                    {!phaseRendered && (
                                                                                        <td rowSpan={phase.records.length}>
                                                                                            {phase.phase}
                                                                                        </td>
                                                                                    )}

                                                                                    {/* Time */}
                                                                                    <td>{record.time}</td>

                                                                                    {/* Day values */}
                                                                                    {days.map(day => (
                                                                                        <td key={day}>{record.days[day]}</td>
                                                                                    ))}

                                                                                    {/* Right summary columns */}
                                                                                    {!pillarRendered && (
                                                                                        <>
                                                                                            <td rowSpan={totalRows}>{pillar.summary.benchmarkMax}</td>
                                                                                            <td rowSpan={totalRows}>
                                                                                                {pillar.summary.min}
                                                                                                <hr style={{ margin: '0px' }} />
                                                                                                {pillar.summary.max}
                                                                                            </td>
                                                                                            {
                                                                                                (RoleID != 45 && RoleID != 46) &&
                                                                                                <td rowSpan={totalRows}>{pillar.summary.defaulterAmp}</td>
                                                                                            }
                                                                                            <td rowSpan={totalRows}>{pillar.summary.unitPenalty}</td>
                                                                                            {
                                                                                                (RoleID != 45 && RoleID != 46) &&
                                                                                                <td rowSpan={totalRows}>{pillar.summary.totalPenalty}</td>
                                                                                            }
                                                                                        </>
                                                                                    )}

                                                                                    {pillarRendered = true}
                                                                                    {phaseRendered = true}
                                                                                </tr>
                                                                            ));
                                                                        })}


                                                                        {/* ================= AVGSUM ROW ================= */}
                                                                        < tr >
                                                                            <td colSpan={5}></td>
                                                                            <td colSpan={0}><b>AvgSum</b></td>


                                                                            {/* {
                                                                            days.map(day => (
                                                                                <td key={day}><b>{pillar.summary.avgSum}</b></td>
                                                                            ))
                                                                        } */}
                                                                            {days.map(day => (
                                                                                <td key={day}><b>{pillar.avgSum[day]}</b></td>
                                                                            ))}



                                                                            <td colSpan={0}></td>
                                                                            <td colSpan={0}></td>
                                                                            {
                                                                                (RoleID != 45 && RoleID != 46) &&
                                                                                <td colSpan={0}></td>
                                                                            }
                                                                            <td colSpan={0}></td>
                                                                            {
                                                                                (RoleID != 45 && RoleID != 46) &&
                                                                                <td colSpan={0}></td>
                                                                            }

                                                                        </tr>

                                                                        {/* ================= DEFAULTER ROW ================= */}
                                                                        <tr>
                                                                            <td colSpan={5}></td>
                                                                            <td colSpan={0}><b>Defaulter</b></td>

                                                                            {/* {days.map(day => (
                                                                            <td key={day}><b>{pillar.summary.defaulterDays}</b></td>
                                                                        ))} */}

                                                                            {days.map(day => (
                                                                                <td key={day}><b>{pillar.defaulterDays[day]}</b></td>
                                                                            ))}

                                                                            {
                                                                                pillar?.defaulterSummary && pillar?.defaulterSummary?.length > 0 && pillar?.defaulterSummary.map(i => {
                                                                                    return (
                                                                                        <>
                                                                                            <td colSpan={0}><b>{i?.benchmarkMax}</b></td>
                                                                                            <td colSpan={0}><b>{i?.minmax}</b></td>
                                                                                            <td colSpan={0}><b>{i?.defaulterAmp}</b></td>
                                                                                            <td colSpan={0}><b>{i?.unitPenalty}</b></td>
                                                                                            <td colSpan={0}><b>{i?.totalPenalty}</b></td>
                                                                                        </>
                                                                                    )
                                                                                })
                                                                            }

                                                                            {/* <td colSpan={0}></td>
                                                                        <td colSpan={0}></td>
                                                                        <td colSpan={0}></td>
                                                                        <td colSpan={0}></td> */}

                                                                        </tr>
                                                                    </>
                                                                );
                                                            })
                                                                :
                                                                <tr>
                                                                    <td colSpan={42}>No Data Found...</td>
                                                                </tr>
                                                        }
                                                    </tbody>
                                                </table>



                                                {/* <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Project Type</th>
                                                            <th>Procedure name</th>
                                                            <th>Execution Date</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            TableData && TableData.length > 0 ? TableData.map((i, j) => {
                                                                return (
                                                                    <tr style={{ width: '100%' }}>
                                                                        <td style={{ textAlign: "center" }}>{j + 1}</td>
                                                                        <td>{i?.details_SP}</td>
                                                                        <td>{i?.name_SP}</td>
                                                                        <td style={{ width: '10%', textAlign: "center" }}>
                                                                            <span className="btn btn-secondary float-center"
                                                                                onClick={() => handleView(i)}
                                                                                style={{ color: "white" }}>
                                                                                <text className="poppins" style={{ fontStyle: 'normal' }}>Date View</text>
                                                                            </span>
                                                                        </td>

                                                                        <td style={{ width: '10%', textAlign: "center" }}>
                                                                            <i className="btn btn-secondary float-center"
                                                                                // onClick={() => handleCallRunPost(i)}
                                                                                onClick={() => handleRunPost(i)}
                                                                                style={{ color: "white" }}>
                                                                                <text className="poppins" style={{ fontStyle: 'normal' }}>RUN</text>
                                                                            </i>
                                                                        </td>

                                                                    </tr>
                                                                )
                                                            })
                                                                :
                                                                <tr><td colSpan={4}>No Data Found</td></tr>
                                                        }



                                                    </tbody>
                                                </table> */}

                                            </div>
                                            {/* {tableData && tableData.table && tableData.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            } */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {
                    ExecutionDateViewPopUp ?
                        <ExecutionDateModal
                            open={ExecutionDateViewPopUp}
                            GridData={GridData}
                            handleViewClose={handleViewClose}
                            Month={Month}
                            FinancialYear={FinancialYear}
                        />
                        : <></>
                }
            </div >
        </>
    )
}